import React, { useEffect } from "react";
import { Redirect, Route, Router, Switch } from "react-router-dom";

import Signup from './Pages/Signup/SignUp';
import SignIn from './Pages/Signin/SignIn';
import ProductList from "./Pages/Products/productsPage";
import Channels from "./Pages/ChannelPage/channelPage"
import Pricing from "./Pages/pricingPage"
import VaraintList from "./Pages/variantListPage"
import Users from "./Pages/UsersPage/usersPage"
import Permissions from "./Pages/userPermissionPage"
import CreateReport from "./Pages/createReportPage"
import ReportList from "./Pages/reportListPage"
import Report from "./Pages/showReportPage"
import Dashboard from "./Pages/dashboardPage/dashboardPage"
import Profile from "./Pages/ProfilePage/ProfilePage"
import UserPackages from "./Pages/UserpPackagesPage"
import ProtectedRoute from "./ProtectedRoute"
import NotFound from "./Pages/notFound/notFound";
import ServerError from "./Pages/serverError/serverError"
import Payment from "./Pages/paymentPage"
import ProReportList from "./Pages/ProReportListPage"
import proReportShow from "./Pages/showProReportPage"
import paymentResult from "./Pages/paymentResult"
import Guide from "./Pages/guides";
import Wallet from "./Pages/wallet/walletPage";
import ChargeWallet from "./Pages/wallet/chargeWalletPage"
import Setting from "./Pages/SettingPage/SettingPage"
import SettingInvoice from "./Pages/SettingPage/SettingInvoice"
import Log from "./Pages/log"
import Cargo from "./Pages/cargoPage/cargoPage"
import SnappShop from "./Pages/snappShopPage/snappShopPage"
import SnappShopVariants from "./Pages/snappShopVariantsPage/snappShopVariantsPage"
import OrdersPage from "./Pages/orders/orders"
import Support from "./Pages/supportPage/supportPage"
import Forum from "./Pages/forumPage/forumPage"
import DefaultSetting from "./Pages/DefaultSettingPage/DefaultSettingPage"
import BlackFridayLandig from "./Pages/BlackFriday/BlackFridayLanding"
import BlackFridayListYourProducts from "./Pages/BlackFriday/your-products"
import BlackFridayListCategoryProducts from "./Pages/BlackFriday/category-products"
import BlackFridayListAllProducts from "./Pages/BlackFriday/all-products"
import ReactGA from "react-ga4";

function Routes(props) {

    useEffect(() => {
        props.history.listen(location => {
            if (typeof window != 'undefined') {
                window.scrollTo(0, 0)
            }
        });
    }, [])


    ReactGA.initialize([
        {
            trackingId: "G-K2RVWMVKR7",
        }]);
    ReactGA.send({ hitType: "pageview" });

    return (
        <Router history={props.history}>
            <Switch>
                <Route exact path="/signup/:step" component={Signup} />
                <Route exact path="/signin/:step" component={SignIn} />
                <Route exact path="/500" component={ServerError} />
                <ProtectedRoute exact path="/guide" component={Guide} />
                <ProtectedRoute exact path="/" component={Dashboard} />
                <ProtectedRoute exact path="/users" component={Users} />
                <ProtectedRoute exact path="/users/permission" component={Permissions} />
                <ProtectedRoute exact path="/variants" component={VaraintList} />
                <ProtectedRoute exact path="/products" component={ProductList} />
                <ProtectedRoute exact path="/channels" component={Channels} />
                <ProtectedRoute exact path="/pricing" component={Pricing} />
                <ProtectedRoute exact path="/report/reportlist" component={ReportList} />
                <ProtectedRoute exact path="/report/proreportlist" component={ProReportList} />
                <ProtectedRoute exact path="/report/proreportshow/:id" component={proReportShow} />
                <ProtectedRoute exact path="/report/create" component={CreateReport} />
                <ProtectedRoute exact path="/report/show/:id" component={Report} />
                <ProtectedRoute exact path="/profile" component={Profile} />
                <ProtectedRoute exact path="/userpackages" component={UserPackages} />
                <ProtectedRoute exact path="/packageconfirm/:name" component={Payment} />
                <ProtectedRoute exact path="/payment/result/:transactionid" component={paymentResult} />
                <ProtectedRoute exact path="/wallet" component={Wallet} />
                <ProtectedRoute exact path="/chargewallet" component={ChargeWallet} />
                <ProtectedRoute exact path="/log" component={Log} />
                <ProtectedRoute exact path="/setting" component={Setting} />
                <ProtectedRoute exact path="/settinginvoice" component={SettingInvoice} />
                <ProtectedRoute exact path="/cargo" component={Cargo} />
                <ProtectedRoute exact path="/snappshop" component={SnappShop} />
                <ProtectedRoute exact path="/snappshopvariants" component={SnappShopVariants} />
                <ProtectedRoute exact path="/orders" component={OrdersPage} />
                <ProtectedRoute exact path="/support" component={Support} />
                <ProtectedRoute exact path="/forum" component={Forum} />
                <ProtectedRoute exact path="/defaultSetting" component={DefaultSetting} />
                <ProtectedRoute exact path="/blackfriday/landing" component={BlackFridayLandig} />
                <ProtectedRoute exact path="/blackfriday/list/your-products" component={BlackFridayListYourProducts} />
                <ProtectedRoute exact path="/blackfriday/list/category-products" component={BlackFridayListCategoryProducts} />
                <ProtectedRoute exact path="/blackfriday/list/all-products" component={BlackFridayListAllProducts} />
                <Route path="/404"><NotFound /></Route>
                <Redirect to="/404" />

            </Switch>
        </Router>
    );
}

export default Routes;